import { getAppOwnerId } from 'src/core/classes/helpers/getAppId'

interface ICloudinaryUrlParams {
  src: string
  width?: number
  height?: number
  params?: string[]
  withEncodeURIComponent?: boolean
}

export const urlCDN = ({
  src,
  params = [],
  externalType,
}: {
  src: string
  params?: string[]
  externalType?: string
}) => {
  const type = externalType ? externalType : 'image'
  const paramsStr = params.length ? `${params.join(',')}/` : ''
  return `https://res.cloudinary.com/appbuilder/${type}/fetch/${paramsStr}${src}`
}

export const getCloudinaryUrl = ({
  src,
  width = 0,
  height = 0,
  params = [],
  withEncodeURIComponent = false,
}: ICloudinaryUrlParams): string => {
  if (!src) {
    return ''
  }

  const isProduction = getAppOwnerId().includes('-prod')

  const encodeFunction = (val: string) =>
    withEncodeURIComponent && isProduction
      ? encodeURIComponent(decodeURIComponent(val))
      : encodeURI(decodeURI(val))

  const escapedSrc = encodeFunction(src).replace('(', '%28').replace(')', '%29')

  const srcWithoutCloudinary = src.includes('https://res.cloudinary.com')
    ? escapedSrc.replace(/^.*\/https:\/\//g, 'https://')
    : escapedSrc

  if (!isProduction) {
    return srcWithoutCloudinary
  }

  const newParams = params.length ? params : ['c_fill', 'g_auto', 'f_auto']
  if (width > 0) {
    newParams.push(`w_${width}`)
  }
  if (height > 0) {
    newParams.push(`h_${height}`)
  }
  return urlCDN({ src: srcWithoutCloudinary, params: newParams })
}
